import ArticleContent from './ArticleContent';
import ArticleMeta from './ArticleMeta';

export default class Article {
  meta: ArticleMeta;
  content: ArticleContent;

  constructor(meta: ArticleMeta, content: ArticleContent) {
    this.meta = meta;
    this.content = content;
  }

  public static fromXML(id: string, articleXML: string) {
    const articleMeta = ArticleMeta.fromXML(id, articleXML);
    const articleContent = ArticleContent.fromXML(articleXML);

    const article = new Article(articleMeta, articleContent);

    return article;
  }
}
